import { Col, Row } from "react-bootstrap";
import {
    TrustFlowGridContainer,
    KeywordsGridContainer,
    TrafficGridContainer,
} from "src/app/containers";

const MonitoringDashboard = () => {
    return (
        <Row style={{ height: "100%", display: "flex" }}>
            <Col sm={4}>
                <TrustFlowGridContainer />
            </Col>
            <Col sm={5}>
                <TrafficGridContainer />
            </Col>
            <Col sm={3}>
                <KeywordsGridContainer />
            </Col>
        </Row>
    );
};

export default MonitoringDashboard;
